import React from 'react';
import styled from 'styled-components';
import Modal from '../Modal';
import { Button } from '../../elements';
import { JVCEF } from '~/config/constants';

const ContainerModal = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  padding: 35px 68px 5px;
`;
const Title = styled.h2`
  color: ${({ theme }) => theme.colors.gray400};
  font-size: 1.75rem;
  margin-bottom: 35px;
  position: relative;

  &:before {
    content: '';
    position: absolute;
    top: 6px;
    left: -38px;
    width: 20px;
    height: 70px;
    background-color: ${({ theme }) => theme.colors.secondary};
  }
`;

const Text = styled.p`
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.gray400};
`;
const List = styled.ul`
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.gray400};
  list-style: disc;
  margin-bottom: 35px;
`;
const Link = styled.a`
  color: ${({ theme }) => theme.colors.black};
  font-weight: 600;
`;
const Actions = styled.div`
  padding: 30px;
  display: flex;
  flex-direction: column;
  position: sticky;
  background-color: ${({ theme }) => theme.colors.white};
  bottom: 0;
  left: 0;

  button {
    max-width: unset !important;
    width: auto;
  }
  button:first-child {
    margin-bottom: 10px;
  }

  @media (min-width: ${({ theme }) => theme.devices.mobile}) {
    flex-direction: row;

    button:first-child {
      margin-bottom: 0;
      margin-right: 10px;
    }
  }
`;

interface IValuePair {
  name: string;
  value: string;
}

interface ITerms {
  privacity: IValuePair;
  use: IValuePair;
}

interface IDetails {
  showModal: boolean;
  closeModal: (v: boolean) => void;
  handleAccept: () => void;
  issuer: {
    name: string;
    company: string;
    terms: ITerms;
  };
}

export default function Details({
  showModal,
  closeModal,
  handleAccept,
  issuer,
}: IDetails): JSX.Element {
  const btnColor = issuer?.name === JVCEF ? 'caixa' : 'institutional';
  return (
    // @ts-ignore
    <Modal
      data-testid="modal-show-more"
      open={showModal}
      handleClose={() => closeModal(false)}
      maxWidth="md"
    >
      <ContainerModal>
        <Title>
          Nós utilizamos cookies para diversas funcionalidades, você concorda
          que a {issuer?.company} use e compartilhe cookies nos seguintes
          contextos:
        </Title>
        <List>
          <li>Use meu comportamento para otimizar os serviços do site;</li>
          <li>Me mostre propaganda com base no meu interesse;</li>
          <li>Facilite minha navegação memorizando minhas preferências </li>
        </List>
        <Text>
          Também utilizamos cookies para outras finalidades (como para Analytics),
          e para mais informações a respeito de nossas práticas, acessar{' '}
          <Link
            href={issuer?.terms?.privacity?.value}
            target="_blank"
          >
            Política de Privacidade
          </Link>
          .
        </Text>
      </ContainerModal>
      <Actions>
        {/* @ts-ignore */}
        <Button
          ariaLabel="Aceitar termo de privacidade"
          label="Aceitar termo de privacidade"
          variant="contained"
          onClick={() => handleAccept()}
          color={btnColor}
        />
      </Actions>
    </Modal>
  );
}
